import { useMemo } from 'react';
import { useLingui } from '@lingui/react';
import { translateService } from '@/lib/serviceTranslations';
import { useBillingSettings } from '@/hooks/useBilling';

/**
 * Returns a resolver that translates a service code to a localized name using
 * billing settings. Falls back to the server-provided name (if any) and finally
 * the raw code, so callers never display an empty label.
 */
export function useResolveServiceName() {
  const { i18n } = useLingui();
  const billingSettings = useBillingSettings();
  const billingServices = useMemo(
    () => billingSettings.data?.services ?? [],
    [billingSettings.data?.services],
  );

  return useMemo(() => {
    return (code: string, fallback?: string) => {
      const localized = translateService(code, billingServices, i18n);
      if (localized && localized !== code) return localized;
      return fallback || localized;
    };
  }, [billingServices, i18n]);
}
